import axios from 'axios';

import { apiUrl, baseUrl } from '../config';
import { Auth } from 'aws-amplify';

export const makeUrl = (endpoint, useTrueBaseUrl = false) => {
  const base = useTrueBaseUrl ? baseUrl : apiUrl;
  return `${base}${endpoint}`;
};

export default async (configuration) => {
  try {
    const currentSession = await Auth.currentSession();
    const token = currentSession.accessToken.jwtToken;
    return axios.create({
      ...configuration,
      headers: {
        Authorization: `Bearer ${token}`
        // Origin: `${window.location.origin}`
      }
    }
    );
  } catch (err) {
    return axios.create({ ...configuration });
  }
};
